import { FieldWrapper } from 'DesignSystem';
import { useField } from 'formik';
import React, { FC, ReactNode } from 'react';
import CountryAutocomplete from './CountryAutocomplete';

interface ICountrySelectProps {
  name: string;
  size?: 'small' | 'medium';
  label?: string;
  labelVariant?: 'small' | 'medium' | 'large';
  placeholder?: string;
  isRequired?: boolean;
  helperText?: string | ReactNode;
  disabled?: boolean;
  'data-testid'?: string;
  euCountriesOnly?: boolean;
  showCountryRisk?: boolean;
}

const CountrySelectField: FC<ICountrySelectProps> = ({
  name,
  size = 'small',
  label = 'Country of origin',
  labelVariant = 'small',
  isRequired,
  helperText,
  disabled,
  euCountriesOnly,
  showCountryRisk,
  'data-testid': testId,
}) => {
  const [field, meta, helper] = useField<string | undefined>(name);

  const handleSelectionChange = async (selection: string | null) => {
    await helper.setTouched(true);
    helper.setValue(selection || undefined);
  };

  return (
    <FieldWrapper
      label={label}
      variant={labelVariant}
      required={isRequired}
      tooltip={
        helperText
          ? {
              helperText,
              variant: 'INFO',
            }
          : undefined
      }
    >
      <CountryAutocomplete
        value={field.value}
        size={size}
        disabled={disabled}
        errorMessage={meta.error}
        hasError={!!meta.error && meta.touched}
        onCountrySelect={handleSelectionChange}
        data-testid={testId}
        euCountriesOnly={euCountriesOnly}
        showCountryRisk={showCountryRisk}
      />
    </FieldWrapper>
  );
};

export default CountrySelectField;
